import type { PaymentFormData } from '#/features/payment-edit'
import type { ShipmentDetail } from '#/shared/api/generated/shipment/models'
import { moneyToFormString } from './money'
import {
  toFormCodMethod,
  toFormPaymentMethod,
  toFormPaymentTerm,
  toFormPaymentTerms,
  toFormTermBegins,
} from './payment-enum-map'

function pickString(value: string | null | undefined): string {
  return value ?? ''
}

export function paymentToFormDefaults(
  shipment: ShipmentDetail | undefined,
): PaymentFormData {
  return {
    totalTariff: moneyToFormString(shipment?.tariff),
    deposit: moneyToFormString(shipment?.deposit),
    carrierFee: moneyToFormString(shipment?.carrier_pay),
    paymentMethod: toFormPaymentMethod(shipment?.payment_method),
    paymentTerms: toFormPaymentTerms(shipment?.payment_terms),
    balanceMethod: toFormCodMethod(shipment?.dispatch_cod_method),
    balanceTime: toFormPaymentTerm(shipment?.dispatch_payment_term),
    balanceTermBegins: toFormTermBegins(shipment?.dispatch_term_begins),
    paymentNote: pickString(shipment?.payment_notes),
  }
}
